/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=0face275"
import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports